import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Transfer } from 'antd';
import { space, width } from 'styled-system';

const StyledTransfer = styled(Transfer)`
  ${space}
  ${width}
  width: 100% !important;
`;

export function TransferControl({ settings, name, value, onChange, ...props }) {
  return (
    <StyledTransfer
      width={1}
      name={name}
      targetKeys={value}
      onChange={value => onChange({ target: { name, value } })}
      render={item => item.title}
      {...settings}
      {...props}
    />
  );
}

TransferControl.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  settings: PropTypes.object,
  hasError: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};
